import React from 'react'
import { FaHeart } from "react-icons/fa";


export default function IconFav() {
  return (
    <div className='icon-fav' >
      <FaHeart />
    </div>
  )
}
